import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { UserTwoFactorLogin } from 'app/shared/models/user-twofactor-login.model';

@Component({
  selector: 'app-two-factor-login',
  templateUrl: './two-factor-login.component.html',
  styleUrls: ['./two-factor-login.component.scss']
})
export class TwoFactorLoginComponent implements OnInit {

  submitInProgress: boolean = false
  authenticationId: string;
  authenticationCode: string;
  protected loginMessage: string;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.route
      .queryParams
      .subscribe(params => {
        this.authenticationId = params['authenticationId']
      });

    this.initializeObject();
    this.translateService.get(['account.twoFactorLogin.loginMessage'])
      .subscribe(translations => {
        this.loginMessage = translations['account.twoFactorLogin.loginMessage'];
      });
  }

  initializeObject() {
    this.authenticationCode = null;
  }

  onSubmit(form: NgForm) {
    if (!this.submitInProgress) {
      this.submitInProgress = true;
      this.authenticationService.twoFactorLogin(new UserTwoFactorLogin(this.authenticationId, this.authenticationCode), false, () => this.submitInProgress = false, this.loginMessage);
    }
  }
}
